import "./assets/style.less";
// require("./assets/vendors/iCheck/skins/all.css");
// import "vue-multiselect/dist/vue-multiselect.min.css";
// require("./assets/vendors/bootstrap/js/bootstrap.min.js");
// require("./assets/vendors/iCheck/iCheck.js");